<template>
    <div class="container-fluid mtb15 no-fluid">
        <div class="card mb-3 w-100">
            <img :src="placedIcon" class="card-img-top" alt="">
            <div class="card-body">
                <div class="card-text">
                    <table class="table order-placed-table">
                        <tbody>
                            <tr v-for="row in orderRows" :key="row.label">
                                <td>{{ row.label }}</td>
                                <td>{{ row.value }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
import I18n from "@/lang/i18n.js";
import UiUtils from "@/assets/js/ui_utils.js";
import { getStockTypeLabel } from "@/features/stocks/stock-type-labels";
import placedIcon from "@/assets/images/Placed.svg";

export default {
    props: {
        order: {
            required: true,
            type: Object
        }
    },
    methods: {
        t(key, ...args) {
            const language = typeof this.getUserLanguage === "function" ? this.getUserLanguage() : this.getUserLanguage;
            return I18n.t(key, language, ...args);
        },
        formatNumber(value) {
            const numericValue = Number(value);
            return UiUtils.formatNumber(value, Number.isInteger(numericValue) ? 0 : 2);
        },
        formatPrice(value) {
            return UiUtils.formatPrice(value, this.order?.cc, this.getUserLanguage, 2).replace(" ", "\u00A0");
        }
    },
    computed: {
        placedIcon() {
            return placedIcon;
        },
        getUserLanguage() {
            return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
        },
        stockTypeLabels() {
            return {
                equities: this.t("equitiesLabel"),
                bonds: this.t("bondsLabel"),
                compInstruments: this.t("compInstrumentsLabel"),
                funds: this.t("fundsLabel"),
                reits: this.t("reitsLabel"),
                rights: this.t("rightsLabel"),
                cfd: this.t("cfdLabel"),
                margin: this.t("marginLabel"),
                netting: this.t("nettingLabel"),
                repo: this.t("repoLabel"),
                stocksAndEtfs: this.t("stocksAndEtfsLabel"),
                other: this.t("othersLabel"),
                unknown: this.t("othersLabel")
            };
        },
        instrumentTypeLabel() {
            return getStockTypeLabel(this.order?.stid, this.stockTypeLabels);
        },
        quantityLabel() {
            return 2 === parseInt(this.order?.stid)
                ? this.t("faceValueLabel")
                : this.t("quantityLabel");
        },
        restrictionLabel() {
            return this.order?.restriction
                ? this.order.restriction
                : this.t("noRestrictionsLabel");
        },
        tradeAtCloseLabel() {
            return true === this.order?.tac
                ? this.t("yesLabel")
                : this.t("noLabel");
        },
        orderRows() {
            return [
                { label: this.t("orderLabel"), value: this.order?.oid },
                { label: this.t("timestampLabel"), value: this.order?.time },
                { label: this.t("typeLabel"), value: this.order?.action },
                { label: this.t("orderTypeLabel"), value: this.order?.type },
                { label: this.t("codeLabel"), value: this.order?.code },
                { label: this.t("nameLabel"), value: this.order?.name },
                { label: this.t("exchangeLabel"), value: this.order?.ex },
                { label: this.t("segmentLabel"), value: this.order?.segment },
                { label: this.t("instrumentTypeLabel"), value: this.instrumentTypeLabel },
                { label: this.t("validityLabel"), value: this.order?.expiry_date },
                { label: this.t("restrictionsLabel"), value: this.restrictionLabel },
                { label: this.t("tradeAtCloseLabel"), value: this.tradeAtCloseLabel },
                { label: this.quantityLabel, value: this.formatNumber(this.order?.amount) },
                { label: this.t("estimatedCommissionLabel"), value: this.formatPrice(this.order?.fee) },
                { label: this.t("estimatedTotalLabel"), value: this.formatPrice(this.order?.price) }
            ];
        }
    }
}
</script>

<style scoped>
    img {
        max-height: 5rem;
        max-width: auto;
    }

    .order-placed-table td {
        border-bottom: 1px solid #eee;
        padding: 0.35rem 0.5rem;
        vertical-align: middle;
    }

    .order-placed-table td:last-child {
        font-weight: 700;
        text-align: right;
    }
</style>
